/*
* @requires  util.js
*/

var HebcaMiddleware = HebcaMiddleware || {};
(function($m) {

    function WebSocketWrapper(host) {
        this.host=host;
        this.socket=null;
        this.eventCallback=null;
        this.needCallback = true;
    }

    WebSocketWrapper.prototype.closeCallBack = function(isneed){
        this.needCallback = isneed
    }

    WebSocketWrapper.prototype.connect=function (param) {
        try{
            var that=this;
            $m.debug("WebSocket host:"+this.host);
            this.socket = new WebSocket(this.host);
            $m.debug("WebSocket begin connect...");
            this.socket.onopen = function(){
                $m.debug("WebSocket onopen success");
                var welcome={
                    name: "welcome",
                    time: new Date().getTime()
                };
                that.socket.send('0|'+ JSON.stringify(welcome) );
            };
            this.socket.onclose = function(){
                $m.debug("WebSocket onclose");
                /*if(param && param.fail){
                    param.fail(new Error("连接证书服务失败"));
                }*/
                if (that.needCallback && param && param.close) {
                    param.close(new Error("连接证书服务失败"));
                }
                that.socket=null;
            };
            this.socket.onerror = function(e){
                $m.debug("WebSocket onerror");
                if(that.needCallback && param && param.fail){
                    param.fail(new Error("连接证书服务失败"));
                }
                if(that.needCallback && param && param.disableTryStart!==undefined && param.disableTryStart===true){
                    //do nothing
                }else{
                    document.location.href="HebcaMiddleware://";
                }

                that.socket=null;
            };
            this.socket.onmessage = function(msg){
                $m.debug("WebSocket onmessage success");
                var args  = msg.data.split('|');
                if(args[0] === "0" && args[1].indexOf("welcome")!== -1){
                    $m.debug("Webscoket Welcome");
                    if(param && param.success){
                        param.success(that.middlewareObj);
                    }
                } else if(args[0]==="2"){
                    //event
                    var eventName=args[1];
                    var eventObject=eval("("+args[2]+")");
                    if(that.eventCallback!=null){
                        that.eventCallback.call(that.middlewareObj,eventName,eventObject);
                    }
                }
            }
        } catch(e){
            $m.debug("WebSocket excpetion:"+e.message);
            if(param && param.disableTryStart!==undefined && param.disableTryStart===true){
                //do nothing
            }else{
                document.location.href="HebcaMiddleware://";
            }

            if(param && param.fail){
                param.fail(new Error("连接证书服务失败"));
            }
            else{
                //如果没有定义回调函数接收错误，则直接抛出异常
                throw new Error("连接证书服务失败");
            }
        }
    };

    WebSocketWrapper.prototype.close=function () {
        if(this.socket!==null){
            this.socket.close()
            this.socket=null
        }
    };

    WebSocketWrapper.prototype._sendMessage=function(param){

        var msgSend ='1|'+param.fun;
        if(param.param){
            msgSend+="|"+param.param;
        }

        $m.debug("WebSocket Send: "+msgSend);
        this.socket.send(msgSend);
        var that=this;

        this.socket.onmessage = function(msg){
            $m.debug("WebSocket Recieve: "+msg.data);
            var args  = msg.data.split('|');
            if(args[0]==="1"){
                if(args[1] === param.fun){
                    var json = eval("("+args[2]+")");
                    if(json.ret === 0){
                        if(param.success){
                            param.success(json);
                        }
                    }else{
                        if(param.fail){
                            var e=new Error(json.msg);
                            e.ret=json.ret;
                            param.fail(e);
                        }
                    }
                }
            }
            else if(args[0]==="2"){
                //event
                var eventName=args[1];
                var eventObject=eval("("+args[2]+")");
                if(that.eventCallback!=null){
                    that.eventCallback.call(that.middlewareObj,eventName,eventObject);
                }
            }
            else if(args[0]==="3"){
                //progress
                if(args[1] === param.fun){
                    var json = eval("("+args[2]+")");
                    var currentLength=json.currentLength;
                    var allLength=json.allLength;
                    if(param.progress){
                        param.progress(currentLength,allLength,function (){
                            var msg='3|'+param.fun+'|{"cancel":false}';
                            $m.debug("WebSocket Send: "+msg);
                            that.socket.send(msg);
                        },function () {
                            var msg='3|'+param.fun+'|{"cancel":true}';
                            $m.debug("WebSocket Send: "+msg);
                            that.socket.send(msg);
                        });
                    }
                }
            }
            else {
                //直接丢弃
            }
        }
    };

    WebSocketWrapper.prototype.sendMessage=function(param){
        var that=this;
        if(this.socket==null){
            this.connect({
                success: function () {
                    that._sendMessage(param);
                },
                fail:function (e) {
                    if(param.fail){
                        param.fail(e);
                    }
                }
            })
        }
        else {
            this._sendMessage(param);
        }
    };

    WebSocketWrapper.prototype.onSuccess=function(name,param,value){
        if(value===undefined){
            $m.debug(name + " end success ");
        }
        else{
            $m.debug(name + " end success :",value);
        }

        if(param && param.success){
            param.success(value);
        }
    };

    WebSocketWrapper.prototype.onFail=function(name,param,e){
        $m.debug(name + " failed: ",e);
        if(param && param.fail){
            param.fail(e);
        }
    };

    WebSocketWrapper.prototype.setEventCallback=function(m,callback){
        this.middlewareObj=m;
        this.eventCallback=callback;
    };

    function WebSocketActiveXWrapper(host){
        this.host=host;
    }

    WebSocketActiveXWrapper.prototype.connect=function (param){
        try{
            this.client=new ActiveXObject("HebcaMiddleware.WebSocketClient")
            this.client.Connect(this.host)
            var that=this
            this.client.SetEventHandler(function (eventName,eventObject){
                var obj=eval("("+eventObject+")");
                if(that.eventCallback!=null){
                    that.eventCallback.call(that.middlewareObj,eventName,obj);
                }
            })
            if(param && param.success){
                param.success(this.middlewareObj);
            }
        }catch (e){
            if(param && param.fail){
                param.fail(new Error("连接证书服务失败"));
            }
            else{
                //如果没有定义回调函数接收错误，则直接抛出异常
                throw new Error("连接证书服务失败");
            }
        }
    }

    WebSocketActiveXWrapper.prototype.close=function (){
        if(this.client){
            this.client.Close()
            this.client=null
        }
    }

    WebSocketActiveXWrapper.prototype.sendMessage=function(param){
        try{
            var msgSend ='1|'+param.fun;
            if(param.param){
                msgSend+="|"+param.param;
            }

            if(param.progress) {
                var that=this
                this.client.SetProgressHandler(function (currentLength, allLength) {
                    if(param.progress) {
                        param.progress(currentLength, allLength, function () {
                            var msg = '3|' + param.fun + '|{"cancel":false}';
                            $m.debug("WebSocket Send: " + msg);
                            that.client.SendOnly(msg);
                        }, function () {
                            var msg = '3|' + param.fun + '|{"cancel":true}';
                            $m.debug("WebSocket Send: " + msg);
                            that.client.SendOnly(msg);
                        });
                    }
                })
            }

            $m.debug("WebSocket Send: "+msgSend)
            var resp=this.client.Send(msgSend)
            $m.debug("WebSocket Recieve: "+resp);

            var args  = resp.split('|');
            if(args[0]==="1"){
                if(args[1] === param.fun){
                    var json = eval("("+args[2]+")");
                    if(json.ret === 0){
                        if(param.success){
                            param.success(json);
                        }
                    }else{
                        if(param.fail){
                            var e=new Error(json.msg);
                            e.ret=json.ret;
                            param.fail(e);
                        }
                    }
                }
            } else {

            }
        }catch(e){
            if(param.fail){
                param.fail(e);
            }
        }
    }

    WebSocketActiveXWrapper.prototype.onSuccess=function(name,param,value){
        if(value===undefined){
            $m.debug(name + " end success ");
        }
        else{
            $m.debug(name + " end success :",value);
        }

        if(param && param.success){
            param.success(value);
        }
    };

    WebSocketActiveXWrapper.prototype.onFail=function(name,param,e){
        $m.debug(name + " failed: ",e);
        if(param && param.fail){
            param.fail(e);
        }
    };

    WebSocketActiveXWrapper.prototype.setEventCallback=function(m,callback){
        this.middlewareObj=m;
        this.eventCallback=callback;
    };

    function createWebSocketWrapper(param,host){
        if($m.util.isIE()){
            var version=9     //默认9以下采用ActiveX
            if(param.ieVersionActive){
                version=param.ieVersionActive
            }
            if($m.util.ieVersion()<=version){
                return new WebSocketActiveXWrapper(host)
            } else {
                return new WebSocketWrapper(host)
            }
        } else {
            return new WebSocketWrapper(host)
        }
    }

    $m.WebSocketWrapper=WebSocketWrapper;
    $m.WebSocketActiveXWrapper=WebSocketActiveXWrapper;
    $m.createWebSocketWrapper=createWebSocketWrapper;

})(HebcaMiddleware);


